import cx from "classnames";
import { useCallback } from "react";

import DownloadFileButton from "components/DownloadFileButton";
import FormFieldViewText from "components/FormFields/ViewText";
import ThemedLogs from "components/ThemedLogs";
import ThemedLogsContent from "components/ThemedLogs/Content";
import { Expand } from "components/icons/generated";
import Box from "ds/components/Box";
import ButtonIcon from "ds/components/ButtonIcon";
import FormField from "ds/components/Form/Field";
import useAnalytics from "hooks/useAnalytics";
import { prettify } from "components/Run/elements/ResourcesDiff/helpers";

import { ConfigNode } from "../../types";
import styles from "./styles.module.css";

type ConfigManagementTreeGridDrawerLogsProps = {
  task: ConfigNode;
  toggleFullScreen: (value?: boolean) => void;
  fileName: string;
};

const ConfigManagementTreeGridDrawerLogs = ({
  task,
  toggleFullScreen,
  fileName,
}: ConfigManagementTreeGridDrawerLogsProps) => {
  const trackSegmentAnalyticsEvent = useAnalytics();

  const openFullScreen = useCallback(() => {
    toggleFullScreen(true);
  }, [toggleFullScreen]);

  const downloadCallback = useCallback(() => {
    trackSegmentAnalyticsEvent("Logs downloaded");
  }, [trackSegmentAnalyticsEvent]);

  return task.logs ? (
    <FormField
      className={cx(styles.label, styles.logsField)}
      labelGrow="1"
      label={
        <Box fullWidth align="center" justify="between">
          Logs
          <Box align="center" gap="small">
            <DownloadFileButton
              value={task.logs}
              title="Download logs"
              fileName={fileName}
              variant="ghost"
              onClickCapture={downloadCallback}
            />
            <ButtonIcon icon={Expand} onPress={openFullScreen} variant="ghost">
              Enter full screen
            </ButtonIcon>
          </Box>
        </Box>
      }
    >
      <ThemedLogs className={styles.logsEditor}>
        <ThemedLogsContent>{prettify(task.logs)}</ThemedLogsContent>
      </ThemedLogs>
    </FormField>
  ) : (
    <FormFieldViewText label="Log" value="No log available" />
  );
};

export default ConfigManagementTreeGridDrawerLogs;
